import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// @mui
// import { Stack } from '@mui/material';
import { Stack, FormControlLabel, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { login } from '../services/api/auth';
import { showSnackbar } from '../components/notification';
import TextInput from '../components/inputs/textInput/textInput';
import { PasswordRequirementCheckBoxes } from '../components/inputs/textInput/password.requirements';

import './form.scss';

// ----------------------------------------------------------------------

export default function LoginForm() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isRememberMe, setIsRememberMe] = useState(false);
    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState({
        eightCharacter: false,
        containNumber: false,
        containUpperCase: false,
        containSpecialChar: false
    });

    /**
    * To validate password requirement
    * @param {String} password 
    */
    const validatePassword = (password) => {
        const rules = {
            eightCharacter: false,
            containNumber: false,
            containUpperCase: false,
            containSpecialChar: false
        }

        if (password.length > 7) { // To check if password contain 8 chars
            rules.eightCharacter = true;
        }
        if (/\d/.test(password)) { // To check if password contain numbers
            rules.containNumber = true;
        }
        if (password !== password.toLowerCase()) { // To check if password contain uppercase
            rules.containUpperCase = true;
        }
        const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (format.test(password)) { // To check if password contain special chars
            rules.containSpecialChar = true;
        }
        setValidPassword(rules)
        if (rules.containNumber &&
            rules.containSpecialChar &&
            rules.containUpperCase &&
            rules.eightCharacter
        ) {
            setPassword(password)
        } else {
            setPassword('')
        }
    }

    const onSubmit = () => {
        setIsLoading(true);
        login({ email, password, isRememberMe }).then((data) => {
            if (data.success) {
                navigate('/', { replace: true });
                showSnackbar().success(data.message)
            } else {
                showSnackbar().failure(data.message)

            }
        }).finally(() => setIsLoading(false))
            ;
    };

    return (
        <>

            <Stack className='login-form standard-form' spacing={3}>
                <TextInput
                    key={`login-email`}
                    label='Email'
                    name='email'
                    type='email'
                    required
                    placeholder='Please enter your email address'
                    className='custom-textfield'
                    getValue={(_, value) => setEmail(value)}

                />

                <TextInput
                    key={`login-password`}
                    label='Password'
                    name='password'
                    type='password'
                    isRequired={false}
                    placeholder='Please enter your password'
                    className='custom-textfield'
                    getValue={(_, value) => validatePassword(value)}

                />
                <PasswordRequirementCheckBoxes rules={validPassword} />
                <Stack className='additional-btn' variant='div' spacing={3} style={{ marginTop: '0' }}>
                    <FormControlLabel className='rememberMe' control={<Checkbox color='primary' onChange={(e) => setIsRememberMe(e.target.checked)} />} label="Remember me" />
                    <p style={{ textAlign: 'right' }}><Link to={'/auth/forgot-password'}>Forgot your password?</Link></p>
                </Stack>
                <LoadingButton
                    loading={isLoading}
                    loadingPosition='start'
                    startIcon={<></>} // To remove Mui warning
                    fullWidth
                    disabled={!email || !password}
                    size="large"
                    type="submit"
                    variant="contained"
                    className='standard-btn'
                    onClick={onSubmit}>
                    Login
                </LoadingButton>

            </Stack>

            <Stack className='additional-btn' variant='div' spacing={3}>
                <p>Don’t have an account yet? <Link to={'/auth/register'}>Sign up</Link></p>
            </Stack>
        </>
    );
}
